export const es_api_url = process.env.REACT_APP_ES_API_URL;
export const ku_api_url = process.env.REACT_APP_KU_API_URL;
export const blob_api_url = process.env.REACT_APP_BLOB_API_URL;
export const client_id = process.env.REACT_APP_CLIENT_ID;
